import Axios from "../../utils/axiosInstance";

export const getMyPresenceStatus = () => {
    return Axios.get("/api/Presence/GetMyStatus");
};

export const setPresenceStatus = (status) => {
    return Axios.post("/api/Presence/SetStatus", { status });
};
